export function getAgreeTermAndConditions(state) {
    return {
        agreeTermCond: state.TermAndConditions?.agreeTermCond
    }
}